import classNames from "classnames";

interface Props {
    label: string | any;
    type?: "cardTitle" | "description" | "highlighter";
    cName?: string;
}

const Text = ({ label, type, cName }: Props) => {
       <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Instrument+Sans:wght@400;500;600;700&&family=Inter:wght@400;500;600;700;&display=swap');
           `}</style>
    if (type === "highlighter")
        return <h2 className={classNames(cName || "text-transparent bg-clip-text bg-gradient-to-r from-[#E5542F] to-[#8431D6] font-semibold text-sm tracking-wide")} style={{ fontFamily: 'Instrument Sans, sans-serif' }}>
            {label}
        </h2>
    else if(type === "cardTitle") 
        return <p className={classNames(cName || "text-[#181818] text-pretty text-4xl font-bold tracking-tight md:text-3xl sm:text-2xl")} style={{ fontFamily: 'Inter, sans-serif' }}>
            {label}
        </p>
    else if(type === "description")
        return <p className={classNames(cName || "text-sm  text-[#636363] font-medium sm:text-xs sm:leading-5")} style={{ fontFamily: 'Instrument Sans' }} >
            {label}
        </p>
    else 
        return <span className={classNames(cName)}>{label}</span>
}

export default Text;